<template>
  <inactive-view class="feedback-content" v-if="Object.keys(currentMerchant).length && !currentMerchant.feedback_integrated" />
  <div class="feedback-content" v-else-if="currentMerchant.feedback_integrated">
    <header-nav-panel 
      @clickedHeader="changeHeader"
      :currentHeader="currentHeader"/>
    <dashboard-landing-page v-if="currentHeader == 'dashboard'"/>
    <analytics-landing-page v-if="currentHeader == 'analytics'"/>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import RemoveRailsLoadingMixin from '../../mixins/RemoveRailsLoadingMixin';
  import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin';
  import InactiveView from '../../components/Feedbacks/InactiveView';
  import DashboardLandingPage from '../../components/Feedbacks/Dashboard/DashboardLandingPage';
  import AnalyticsLandingPage from '../../components/Feedbacks/ScoringAnalytics/AnalyticsLandingPage';
  import HeaderNavPanel from '../../components/Feedbacks/HeaderNavPanel';
  import { Tabs, Tab, Tooltip } from 'uiv';

  export default {
    name: 'FeedbackShow',
    components: {
      InactiveView,
      DashboardLandingPage,
      AnalyticsLandingPage,
      HeaderNavPanel,
      Tabs,
      Tab,
      Tooltip
    },
    mixins: [RemoveRailsLoadingMixin, UserAbilitiesMixin],
    data() {
      return {
        currentHeader: 'dashboard'
      }
    },
    async created() {
      this.$store.dispatch('LOAD_CURRENT_MERCHANT').then(() => {
        this.removeLoading('campaign-show-loading-icon')
      })
      this.$store.dispatch('LOAD_CURRENT_USER')
      document.title = 'feedback'

      // Hide alert bubble if present
      // ref: app/views/application/_alert_bubble.html.slim
      const alertBubble = document.querySelector('#content > .top-row > .alert_bubble_dashboard')
      if(alertBubble) alertBubble.setAttribute("hidden", true)
    },
    mounted() {},
    computed: {
      ...mapGetters(
        ['userAbilitiesValue']
      ),

      ...mapState([
        'currentMerchant'
      ])
    },
    methods: {
      changeHeader(val) {
        this.currentHeader = val
      }
    }
  }

</script>
